/**
 * Derivations for the non-PII person properties sent to PostHog at identify
 * time.
 *
 * Internal staff log into customer tenants, so internal activity cannot be
 * excluded by tenant — the exclusion has to be per user. These two booleans
 * are the signal analytics filters on; the values they are derived from
 * (email, the raw tenant claim) never leave the client.
 */

const INTERNAL_EMAIL_DOMAIN = '@planitgeo.com';

/**
 * True when the user is a PlanIT Geo employee.
 *
 * Uses the same case-sensitive suffix test as the API's admin guard
 * (`jwt-auth-admin.guard.ts`) so analytics agrees with the system's existing
 * definition of internal.
 *
 * An unknown email yields `false`, never `undefined`: unknown must mean "not
 * known to be internal" so the user stays counted as a customer. Treating
 * unknown as excluded is the bug this replaces.
 */
export function deriveIsInternal(email: string | undefined | null): boolean {
  return typeof email === 'string' && email.endsWith(INTERNAL_EMAIL_DOMAIN);
}

/**
 * True when the user can see every tenant.
 *
 * Strict equality only — `tp3_tenant_ids` is a comma-separated list, so
 * `'tenant-a,*'` is a two-tenant list and NOT all-tenant access. A substring
 * or `includes('*')` test would silently misclassify those users.
 */
export function deriveHasAllTenantAccess(tp3TenantIds: string | undefined | null): boolean {
  return tp3TenantIds === '*';
}
